
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IQueue } from '../../../models/queue';
import QueueJobState from "./QueueJobState.vue";

  @Component({
    components: {
      QueueJobState
    }
  })
  export default class TableItemModificator extends Vue {

    @Prop()item!: IQueue
    
  }
